<ngb-pagination [collectionSize]="total()" [page]="page()" (pageChange)="page.set($event)" [pageSize]="pageSize()" [ellipses]="true" [maxSize]="10"></ngb-pagination>

<select class="form-select" style="width: auto" name="pageSize" aria-label="Items per page" [value]="pageSize()" (change)="onPageSize(+$any($event.target).value)">
    @for (size of globalService.pagination; track size) {
        <option [value]="size" [selected]="size === pageSize()">{{ size }} items per page</option>
    }
</select>
